import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import config from "../../config/config";
import moment from "moment";
import { event } from "jquery";
import { set } from "react-hook-form";
import jsPDF from "jspdf";
import MaterialReactTable from "material-react-table";

const SupplierStatement = () => {
  const paramObject = useParams();
  let ID = paramObject.id;
  const token = localStorage.getItem("Token");

  const [supplierDetails, setSupplierDetails] = useState([]);
  const [statementList, setStatementList] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [beginningDate, setBeginningDate] = useState();
  const [finalDate, setFinalDate] = useState();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // const columns = useMemo(() => [
  //   {

  //     //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
  //     //     //           to={`/manage-customers/${row.Id}`}
  //     //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //     //     //         >
  //     //     //           Edit
  //     //     //         </Link>
  //     //     //       )}
  //     //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
  //     //     //         <>
  //     //     //           <button
  //     //     //             type="button"
  //     //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //     //     //             data-bs-toggle="dropdown"
  //     //     //             aria-haspopup="true"
  //     //     //             aria-expanded="false"
  //     //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //     //     //           >
  //     //     //           </button>
  //     //     //           <div className="dropdown-menu">
  //     //     //             {checkUserPermission(PERMISSION_EDIT) ? (
  //     //     //               <li>
  //     //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
  //     //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
  //     //     //                 </Link>
  //     //     //               </li>
  //     //     //             ) : (
  //     //     //               ""
  //     //     //             )}
  //     //     //             {checkUserPermission(PERMISSION_DELETE) ? (
  //     //     //               <li>
  //     //     //                 <Link
  //     //     //                   className="dropdown-item confirm-text"
  //     //     //                   to="#"
  //     //     //                   title="Delete"
  //     //     //                   data-bs-toggle="modal"
  //     //     //                   data-bs-target="#DeleteConfirmationModal"
  //     //     //                   onClick={() => handleDeletePopup(row.Id)}
  //     //     //                 >
  //     //     //                   <i
  //     //     //                     className="fa fa-trash"
  //     //     //                     data-bs-toggle="tooltip"
  //     //     //                     title="Delete"
  //     //     //                   ></i>
  //     //     //                   Delete
  //     //     //                 </Link>
  //     //     //               </li>
  //     //     //             ) : (
  //     //     //               ""
  //     //     //             )}
  //     //     //           </div>
  //     //     //         </>
  //     //     //       )}
  //     //     //     </div>
  //     //     //   ),
  //     //     //   ignoreRowClick: true,
  //     //     //   allowOverflow: true,
  //     //     //   button: true,
  //     //     //   //width: "7%",//"100px",
  //     //     //   minWidth: "90px",
  //     //     //   width: "90px",
  //     //     // },
  //     //     // {
  //     //     //   name: "Company Name",
  //     //     //   selector: "CompanyName",
  //     //     //   sortable: true,
  //     //     //   width: "170px",
  //     //     //   cell: (row) => (

  //     //     //     <>
  //     //     //       {checkUserPermission(PERMISSION_EDIT) ?
  //     //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
  //     //     //           {row.CompanyName}
  //     //     //         </Link>
  //     //     //         :
  //     //     //         row.CompanyName
  //     //     //       }
  //     //        header: "Company Name",
  //     //       accessorKey: "CompanyName",
  //     //       // enableGrouping: false, //do not let this column be grouped
  //     //     },
  //     //     {
  //     //       header: "Name",
  //     //       accessorKey: "Name",
  //     //       Cell: ({ row }) => (
  //     //         <>
  //     //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
  //     //             {row.original.FirstName} {row.original.LastName}
  //     //           </Link>
  //     //         </>
  //     //       ),

  //     //       // enableGrouping: false, //do not let this column be grouped
  //     //     },
  //     //     // {
  //     //     //   header: "DATE",
  //     //     //   accessorKey: "DATE",
  //     //     //   Cell: ({row})=> moment(row.original.DATE).format("YYYY-MM-DD")
  //     //     // },
  //     //     {
  //     //       header: "E-Mail",
  //     //       accessorKey: "Email",
  //     //       Cell: ({ row }) => (
  //     //         <>
  //     //           <p title={row.original.Email}>{row.original.Email}</p>
  //     //         </>
  //     //       ),
  //     // =======
  //     header: "Date",
  //     accessorKey: "Date",
  //     Cell: ({ row }) => moment(row.original.Date).format("DD-MM-YYYY")
  //   },
  //   {
  //     header: "Details",
  //     accessorKey: "Details",

  //   },
  //   {
  //     header: "Amount",
  //     accessorKey: "Amount",
  //   },
  //   {
  //     header: "Payments",
  //     accessorKey: "Payments",
  //   },
  //   {
  //     header: "Balance",
  //     accessorKey: "Balance",

  //   },

  //   {
  //     header: "Profile",
  //     accessorKey: "Image",
  //     Cell: ({ row }) => (
  //       <>
  //         <a href={row.original.Image} target="_blank">
  //           <img
  //             src={row.original.Image}
  //             alt="Profile Image"
  //             style={{
  //               maxWidth: "30px",
  //               maxHeight: "70px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               e.target.src = Noimage;
  //             }}
  //           ></img>
  //         </a>
  //       </>
  //     ),
  //   },
  //   {
  //     header: "Created On",
  //     accessorKey: "CreatedDate",
  //     Cell: ({ row }) => formatDate(row.original.CreatedDate),
  //   },  {
  //     header: "Account Balance",
  //     accessorKey: "Balance",
  //     Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
  //   },
  // ]);

  const columns = [
    {
      name: "Date",
      width: "160px",
      selector: (row) => moment(row["Date"]).format("DD-MM-YYYY"),
      sortable: false,
    },
    {
      name: "Details",
      width: "420px",
      cell: (row) => {
        return <div style={{ width: "320px" }}>{row?.Details}</div>;
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "3px",
          }}
        >
          Amount
        </div>
      ),
      cell: (row) => {
        return (
          <div className="text-right" style={{ width: "108px" }}>
            {row?.Amount}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "22px",
          }}
        >
          Payments
        </div>
      ),
      // width:"125px",
      cell: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {row?.Payments}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "30px",
          }}
        >
          Balance
        </div>
      ),
      width: "130px",
      cell: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {row?.Balance}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "This Month",
    value: 3,
  });
  const options = [
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Period", value: 7 },
  ];

  //Date

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const handleQuickBookChange = (event) => {
    console.log(event, "eventtt");
    setDateFilter(event?.value);
    if (event?.value !== 7) {
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    }
  };

  const handleDate = (event) => {
    console.log(event?.target?.value, "eventisss92");
    setStartDate(event?.target?.value);
    setBeginningDate(event?.target?.value);
  };

  const handleEndDate = (event) => {
    setEndDate(event?.target?.value);
    setFinalDate(event?.target?.value);
  };

  console.log(dateFilter, "dateFilter");

  //Search

  //Search Button
  const handleSearch = () => {
    console.log(startDate, endDate, "1555");
    supplierStatementApi(startDate, endDate);
  };

  const dateFilterData =
    dateFilter == 1 ? (
      <p>{beginningDate + " To " + beginningDate}</p>
    ) : dateFilter === 4 ? (
      <p>{startOfWeek + " To " + endOfWeek}</p>
    ) : dateFilter === 3 ? (
      <p>{startOfMonth + " To " + endOfMonth}</p>
    ) : dateFilter === 6 ? (
      <p>{startOfLastMonth + " To " + endOfLastMonth}</p>
    ) : dateFilter === 5 ? (
      <p>{startOfYear + " To " + endOfYear}</p>
    ) : dateFilter === 2 ? (
      <p>{startOfLastYear + " To " + endOfLastYear}</p>
    ) : dateFilter === 7 ? (
      startDate === undefined ? (
        <p>{today + " To " + today}</p>
      ) : (
        <p>{startDate + " To " + endDate}</p>
      )
    ) : (
      <p>{startOfMonth + " To " + endOfMonth}</p>
    );

  const supplierStatementApi = () => {
    let sDate = beginningDate == undefined ? startOfMonth : beginningDate;
    let fDate = finalDate == undefined ? endOfMonth : finalDate;
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierstatement?supplierid=${ID}&startdate=${sDate}&enddate=${fDate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res, "res138");
        setSupplierDetails(res?.data?.ResponseData?.SupplierDetails);
        setStatementList(res?.data?.ResponseData?.StatementList);
      });
  };

  useEffect(() => {
    supplierStatementApi();
  }, [dateFilter]);

  console.log("statementList 242", statementList);

  // Print Statement Function-
  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 17;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(statementList.length / 27); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "3.3rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Sr No.</th>' +
        '<th style="padding: 8px;">Date</th>' +
        '<th style="padding: 8px; width: 300px">Details</th>' +
        '<th style="padding: 8px;">Amount</th>' +
        '<th style="padding: 8px;">Payments</th>' +
        '<th style="padding: 8px;">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < statementList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          moment(statementList[index].Date).format("DD-MM-YYYY") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px; width: 300px">' +
          statementList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 26;
    }

    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  // Send Mail Function-
  const handleMailPdf = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 17;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(statementList.length / 27); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "3.3rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Sr No.</th>' +
        '<th style="padding: 8px;">Date</th>' +
        '<th style="padding: 8px; width: 300px">Details</th>' +
        '<th style="padding: 8px;">Amount</th>' +
        '<th style="padding: 8px;">Payments</th>' +
        '<th style="padding: 8px;">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < statementList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          moment(statementList[index].Date).format("DD-MM-YYYY") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px; width: 300px">' +
          statementList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          statementList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 26;
    }

    doc.html(content, {
      callback: function (pdf) {
        const pdfBlob = pdf.output("blob");

        // Create a data URL from the PDF Blob
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Prepare the email subject and body
        const emailSubject = encodeURIComponent("");
        const emailBody = encodeURIComponent("");

        // Create the mailto link with the PDF data URL as attachment
        const mailtoLink = `mailto:?subject=${emailSubject}&body=${emailBody}&attachment=${pdfDataUrl}`;

        // Open the default email client (Gmail) with the mailto link
        window.location.href = mailtoLink;
      },
    });
  };

  return (
    <div className={"col-lg-10 col-md-12"}>
      <div className="card bg-white" style={{ borderRadius: "10px" }}>
        <div style={{ fontWeight: "300", margin: "10px 0 0 10px" }}>
          <h4 className="customer-profile-group-heading">Supplier Statement</h4>
        </div>
        <hr style={{ color: "#cfcfcf" }} />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <div style={{ width: "20%", marginLeft: "20px" }}>
            Date Filter:
            <Select
              defaultValue={quickBookOptions}
              onChange={(event) => {
                handleQuickBookChange(event);
              }}
              options={options}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              isClearable={true}
              hideSelectedOptions={true}
            />
          </div>
          {dateFilter === 7 && (
            <>
              <div style={{ width: "20%", marginTop: "3px" }}>
                Start Date:-
                <input
                  type="date"
                  className="form-control"
                  id="StartDate"
                  name="StartDate"
                  value={startDate}
                  // defaultValue={todayDate}
                  onChange={(event) => handleDate(event)}
                />
              </div>
              <div style={{ width: "20%", marginTop: "3px" }}>
                End Date:-
                <input
                  type="date"
                  className="form-control"
                  id="EndDate"
                  name="EndDate"
                  min={startDate}
                  value={endDate}
                  // defaultValue={todayDate}
                  onChange={(event) => handleEndDate(event)}
                />
              </div>
              <button
                className="btn btn-primary"
                style={{
                  height: "fit-content",
                  marginTop: "22px",
                }}
                onClick={(e) => handleSearch(e)}
              >
                Search
              </button>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-print" onClick={handlePrint} />
            </div>
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-envelope" onClick={handleMailPdf} />
            </div>
          </div>
        </div>
        {/* Print Statement */}
        <div className="card-body">
          <div
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            {/* Header */}
            <div id="header">
              <div className="text-right">
                {supplierDetails?.map((el) => {
                  return (
                    <>
                      <p
                        className="h-tag"
                        style={{
                          fontWeight: "bold",
                          margin: "0",
                        }}
                      >
                        {el?.Companyname}
                      </p>
                      <span>{el?.Address1 + " " + el?.Address2}</span>
                      <br />
                      <span>
                        {el?.City + " , " + el?.State + " , " + el?.Country}
                      </span>
                      <br />
                      <span>{el?.Zip}</span>
                    </>
                  );
                })}
              </div>
              <hr style={{ color: "#cfcfcf" }} />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {supplierDetails.map((el) => {
                  return (
                    <div
                      style={{
                        width: "22%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <strong>To:</strong>
                      </div>
                      <div>{el?.FirstName + " " + el?.LastName}</div>
                    </div>
                  );
                })}
                <div className="text-right">
                  <p
                    className="h-tag"
                    style={{
                      fontWeight: "bold",
                      margin: "0",
                    }}
                  >
                    Account Summary
                  </p>
                  {dateFilterData}
                </div>
              </div>
              <hr
                style={{ width: "30%", marginLeft: "auto", color: "#cfcfcf" }}
              />
              <div
                className="text-right"
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                {supplierDetails?.map((el) => {
                  return (
                    <>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          justifyContent: "space-between",
                          marginLeft: "555px",
                        }}
                      >
                        <div>
                          <div className="text-left">
                            <strong>Beginning Balance:</strong>
                          </div>
                          <div className="text-left">
                            <strong>Invoiced Amount:</strong>
                          </div>
                          <div className="text-left">
                            <strong>Amount Paid:</strong>
                          </div>
                          <div className="text-left">
                            <strong>Credit Applied:</strong>
                          </div>
                        </div>
                        <div>
                          <div>${el?.BeginningBalance}</div>
                          <div>${el?.InvoicedAmount}</div>
                          <div>${el?.AmountPaid}</div>
                          <div>
                            $
                            {el?.CreditAppliedAmount > 0
                              ? el?.CreditAppliedAmount
                              : 0}
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{
                          width: "30%",
                          marginLeft: "auto",
                          color: "#cfcfcf",
                        }}
                      />
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          justifyContent: "space-between",
                          marginLeft: "555px",
                        }}
                      >
                        <div className="text-left">
                          <strong>Balance Due:</strong>
                        </div>
                        <div>${el?.BalanceDue}</div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>

            {/* Date Header */}
            <div
              id="date-header"
              style={{ textAlign: "center", margin: "20px 0 20px 0" }}
            >
              <p>
                Showing all invoices and payments between
                <strong>{dateFilterData}</strong>
              </p>
            </div>

            {/* Table Data */}
            <div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={statementList}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
                {/* <MaterialReactTable
            columns={columns}
            data={data}
            // positionPagination='top'
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            enableRowActions
           
            renderRowActionMenuItems={({ row }) =>

              [
                checkUserPermission(PERMISSION_EDIT) ? (
                  <MenuItem
                    key="edit"
                    onClick={() =>
                      navigate(
                        `/manage-customers/${row.original.Id}`
                      )
                    }
                  >
                    Edit
                  </MenuItem>
                ) : (
                  ""
                ),
                checkUserPermission(PERMISSION_DELETE) ? (
                  <MenuItem
                    className="confirm-text"
                    to="#"
                    // key="delete"

                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#DeleteConfirmationModal"
                    onClick={() =>
                      handleDeletePopup(row.original.Id,"","singlerowdelete")
                    }
                  >
                    Delete
                  </MenuItem>
                ) : (
                  ""
                ),
              ]
            }


        

            rowVirtualizerProps={{
              overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
              estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
            }}


            muiTableContainerProps={{
              sx: { maxHeight: "fit-content" },
            }}
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 10 },
              // sorting: { id: "Name", desc: false }, //sort by state by default
            }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [10, 25, 50, 100, 300],
            }}
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            // enableColumnVirtualization={false}
            // enableColumnVirtualization
            state={{
              // columnFilters, // for termp comment filteron column
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />  */}
              </div>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "2rem",
                }}
              >
                {supplierDetails?.map((el) => (
                  <p style={{ margin: "1rem" }}>
                    <strong>Balance Due </strong>{" "}
                    <span style={{ marginLeft: "2rem" }}>
                      ${el?.BalanceDue}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierStatement;
